import {IAppointment} from '@shared/services/service-mappers/AppointmentMapper';
import moment from 'moment';

export const filterFutureAppointments = (
  appointments: IAppointment[]
): IAppointment[] => {
  return appointments.filter(ap => moment(ap.appointment_at).isAfter(moment()));
};

export const getClinicTimeZone = (
  clinicList: any[],
  clinicId: number
): string => {
  let timezone = '';
  if (clinicList && Array.isArray(clinicList)) {
    const clinic = clinicList.find(c => c.id === clinicId);
    if (clinic) {
      timezone = clinic?.zone;
    }
  }
  return timezone;
};
